module.exports = __webpack_public_path__ + "img/9.53545110.svg";